import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { skip, switchMap } from 'rxjs/operators';
import { SaguiClienteService } from 'src/app/saguicliente/shared/saguicliente.service';
import { ContaParcelaNotaFiscalContaPagar, NotaFiscalContaPagarContaRequest } from './nota-fiscal-conta-pagar.model';

@Injectable()
export class ContaService {

  headers = new HttpHeaders().set('X-Skip-Loader', 'true');

  postEnviaBoletoPorEmail(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/conta/enviaboletoporemail', item, { observe: 'response' })
  };

  postIncluiBoletoPelaContaParcela(item: any): Observable<HttpResponse<any>> {
    console.log(item);
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/conta/incluiboletopelacontaparcela', item, { observe: 'response' })
  };

 corStatusPagamento(contaParcelaCor) {

    let descricao = "Ativo";

    if (contaParcelaCor.statusPagamento == 1) {
      descricao = "Quitado";
    };

    if (contaParcelaCor.statusPagamento == 0) {
      descricao = "Ativo";

      let dataAtual = new Date();
      let dataVencimento = new Date(contaParcelaCor.dataVencimento);

      if (dataAtual.getFullYear() > dataVencimento.getFullYear() ||
          (dataAtual.getFullYear() === dataVencimento.getFullYear() && dataAtual.getMonth() > dataVencimento.getMonth()) ||
          (dataAtual.getFullYear() === dataVencimento.getFullYear() && dataAtual.getMonth() === dataVencimento.getMonth() && dataAtual.getDate() > dataVencimento.getDate())) {
        descricao = "Vencido";
      }
    };

    if (contaParcelaCor.statusPagamento == 2) {
      descricao = "Cancelado";
    };

    if (contaParcelaCor.statusPagamento == 3) {
      descricao = "Estorno";
    };
    
    if (contaParcelaCor.statusPagamento == 6) {
      descricao = "Substituído";
    };

    return descricao;
  }


  getColor(StatusBoleto?: number) {
    if (StatusBoleto == null) {
      return '#f0f0f0'; // Cor padrão quando logTipoEvento é nulo ou indefinido
    }
      //0 - ativo | 1 - baixado | 2 - cancelado | 4 - Erro  | 5 - Processando edição  | 7 - Processando criação | 6 - Processando cancelamento

    switch (StatusBoleto) {
      case 0:
        return '#0684b6';
      case 1:
        return '#72b381';
      case 2:
        return '#666666';
      case 4:
      case 10:
        return '#db5b5b';
      case 5:
        return '#f6a473';
      case 6:
        return '#f6a473';
      case 7:
        return '#f6a473';
      case 8:
        return '#f6a473';
      case 9:
        return '#f6a473';
      default:
        return 'rgba(240, 240, 240, 1)'; // Cor padrão para outros casos
    }
  }

imprimirBoletosEnviarSolicitacao(contaParcelasTemp) {
    if (contaParcelasTemp.length > 0) {
        let boletoIds: any[] = [];
        contaParcelasTemp.forEach(parcela => {
            boletoIds.push(parcela.boletoId);
        });

        this.postVisualizaBoletoPorContaParcela(boletoIds).subscribe(data => {
            let boletos: any[] = data.body;

            boletos.forEach(boleto => {
                // Caso 1: O boleto é um PDF em Base64
                if (boleto.pdf && boleto.pdf.trim() !== "") {
                    try {
                        const byteCharacters = atob(boleto.pdf);
                        const byteNumbers = new Array(byteCharacters.length);
                        for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        const byteArray = new Uint8Array(byteNumbers);
                        const pdfBlob = new Blob([byteArray], { type: 'application/pdf' });
                        const fileURL = URL.createObjectURL(pdfBlob);

                        // Abre a URL do PDF em uma nova aba. Apenas esta chamada é necessária.
                        window.open(fileURL, '_blank');

                    } catch (e) {
                        console.error("Erro ao decodificar o PDF em Base64:", e);
                        // Tenta decodificar a mensagem de erro, se houver
                        try {
                            const mensagemDeErro = atob(boleto.pdf);
                            alert("Não foi possível gerar o boleto: " + mensagemDeErro);
                        } catch (decodeError) {
                            alert("Recebido um dado inválido do servidor ao tentar gerar o boleto.");
                        }
                    }
                }
                // Caso 2: O boleto é um HTML
                else if (boleto.html && boleto.html.trim() !== "") {
                    // Para o caso do HTML, a lógica de criar um popup e escrever nele está correta.
                    let popupWin = window.open('', '_blank', 'width=800,height=600');
                    if (popupWin) {
                        popupWin.document.open();
                        // ... (sua lógica de replaceAll, se houver) ...
                        popupWin.document.write(boleto.html);
                        popupWin.document.close();
                    } else {
                        alert('O bloqueador de pop-ups impediu a abertura do boleto.');
                    }
                }
            });
        });
    }
}


  imprimirBoleto(contaParcelaTemp) {

    let contaParcelasTemp = [];

    if (contaParcelaTemp != undefined) {

      contaParcelasTemp.push(contaParcelaTemp);

    }

    this.imprimirBoletosEnviarSolicitacao(contaParcelasTemp);

  };

  postVisualizaBoletoPorContaParcela(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/conta/visualizaboletoporcontaparcela', item, { observe: 'response' })
  };

  getEmpresas(itemId: any): Observable<HttpResponse<any>> {

    const params = {
      tpConta: itemId,
    };

    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/contaparcela/visualizatodasempresas/', { observe: 'response', params })
  }

  getEmpresasAsync(itemId: any): Observable<HttpResponse<any>> {

    const params = {
      tpConta: itemId,
    };

    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/contaparcela/visualizatodasempresas/', {
        headers: this.headers,
        observe: 'response',
        params
        });
}

  getCaixas(itemId: any, empresaId: any = 0): Observable<HttpResponse<any>> {

    const params = {
      tpConta: itemId,
      empresaId: empresaId
    };

    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/conta/visualizatodascaixas/', { observe: 'response', params })
  }

  getCentroCustos(itemId: any, empresaId: any = 0): Observable<HttpResponse<any>> {

    const params = {
      tpConta: itemId,
      empresaId: empresaId
    };

    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/conta/centrocusto/', { observe: 'response', params })
  }

  getConta(itemId: any): Observable<HttpResponse<any>> {
    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/conta/visualiza/' + itemId, { observe: 'response' })
  }

  postConta(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/conta/inclui', item, { observe: 'response' })
  };

  putConta(itemId: any, item: any): Observable<HttpResponse<any>> {
    return this.http.put(
      environment.webApiSaguiControlUrl + '/api/conta/atualiza/' + itemId, item, { observe: 'response' })
  };

  getParcelasNotaFiscalContaAPagar(contaId: number): Observable<HttpResponse<ContaParcelaNotaFiscalContaPagar[]>> {
    return this.http.get<ContaParcelaNotaFiscalContaPagar[]>(
      environment.webApiSaguiControlUrl + `/api/conta/consultar-parcelas-nota-fiscal-conta-a-pagar/${contaId}`, { observe: 'response' });
  }

  postInformarNotaFiscalContaAPagar(contaId: number, item: NotaFiscalContaPagarContaRequest): Observable<HttpResponse<number>> {
    return this.http.post<number>(
      environment.webApiSaguiControlUrl + `/api/conta/informar-nota-fiscal-conta-a-pagar/${contaId}`, item, { observe: 'response' });
  }

  getIntegracoesSOC(): Observable<HttpResponse<any>>{
    return this.http.get(
        environment.webApiSaguiControlUrl + '/api/conta/verifica-integracoes-soc/', {observe: 'response'})
}

  postVisualizaCliente(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/conta/visualizacliente', item, { observe: 'response' })
  };

  postVisualizaFornecedor(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/conta/visualizafornecedor', item, { observe: 'response' })
  };

  postVisualizaFuncionario(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/conta/visualizafuncionario', item, { observe: 'response' })
  };

     getColorNota(contaparcela: any) {

    if(contaparcela.nfseId>0 &&contaparcela.nfseNumero!==null && contaparcela.nfseNumero!==""){
      return '#72b381';
    }
    if(contaparcela.nfseId>0 && !(contaparcela.nfseNumero!==null && contaparcela.nfseNumero!=="") ){
      return '#f1c773';
    }else{
      return '#f0f0f0'
    }

  }

  getParceiroPorNome(nome: any, tpConta: number): Observable<HttpResponse<any>> {
    let url = '';
    const params = new HttpParams().set('id', nome);

    switch (tpConta) {
      case 0:
        url = 'visualizaclientepornome';
        break;
    case 1:
        url = 'visualizafornecedorpornome';
        break;
     case 2:
        url = 'visualizafuncionariopornome';
        break;
  }

    return this.http.get(
       environment.webApiSaguiControlUrl + '/api/conta/' + url, { observe: 'response', params }
    );

  }

  getAdiantamentoPorContaId(itemId: any): Observable<HttpResponse<any>> {
    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/conta/visualizaadiantamentoporcontaid/' + itemId, { observe: 'response' })
  }

  postFiltraPosicaoConta(item: any, isTenantEducacional: boolean = false): Observable<any> {
    if(isTenantEducacional){
      return this.http.post(
        environment.webApiSaguiEduUrl + '/api/matricula/conta/contasporcliente', item, { observe: 'response' }
      );
    } else {
      return this.http.post(
        environment.webApiSaguiControlUrl + '/api/conta/contasporcliente', item, { observe: 'response' }
      );
    }

  };

  postBuscaDadosGeraisPosicaoContas(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/conta/busca-dados-gerais-posicao-contas', item, { headers: this.headers, observe: 'response' })
  }

  postContaPorPeriodo(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/conta/contasporperiodo/', item, { observe: 'response' })
  }

  postCaixaMovimentoPorFiltro(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/caixamovimento/visualizasaldoporfiltro/', item, { observe: 'response' })
  }

  getTextoTipoPagamento(tipoPagamento: number) {

    let textotipoPagamento = "";

    switch (tipoPagamento) {
      case 0:
        textotipoPagamento = "Dinheiro";
        break;
      case 1:
        textotipoPagamento = "Débito";
        break;
      case 2:
        textotipoPagamento = "Crédito";
        break;
      case 3:
        textotipoPagamento = "Boleto";
        break;
      case 4:
        textotipoPagamento = "Transferência";
        break;
      case 5:
        textotipoPagamento = "Cheque";
        break;
      case 6:
        textotipoPagamento = "Vale Refeição";
        break;
      case 7:
        textotipoPagamento = "Banco";
        break;
      case 8:
        textotipoPagamento = "Prestação de contas";
        break;
    }

    return textotipoPagamento;

  }

  constructor(private http: HttpClient, private sanitizer: DomSanitizer, private saguiClienteService: SaguiClienteService) {

  }
}
